import _asyncToGenerator from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-1efb2772"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("确定");

import { computed, reactive, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { updatePrizePrice } from '@/request';
export default {
  name: 'EditPrizePriceModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const formRef = ref();
    const saving = ref(false);
    const form = reactive({
      price: undefined
    });
    const rules = {
      price: [{
        required: true,
        message: '请填写奖品价格',
        trigger: 'blur'
      }, {
        validator: (_rule, value, callback) => {
          if (value === null || value === undefined || value === '') {
            callback(new Error('请填写奖品价格'));
            return;
          }

          if (Number(value) <= 0) {
            callback(new Error('奖品价格必须大于0'));
            return;
          }

          callback();
        },
        trigger: 'blur'
      }]
    };
    watch(() => props.modelValue, val => {
      if (val) {
        var _props$row, _formRef$value;

        const price = (_props$row = props.row) === null || _props$row === void 0 ? void 0 : _props$row.price;
        form.price = price === null || price === undefined || price === '' ? undefined : Number(price);
        (_formRef$value = formRef.value) === null || _formRef$value === void 0 ? void 0 : _formRef$value.clearValidate();
      }
    });

    function handleConfirm() {
      return _handleConfirm.apply(this, arguments);
    }

    function _handleConfirm() {
      _handleConfirm = _asyncToGenerator(function* () {
        if (saving.value) {
          return;
        }

        try {
          var _formRef$value2;

          yield (_formRef$value2 = formRef.value) === null || _formRef$value2 === void 0 ? void 0 : _formRef$value2.validate();
        } catch (_unused) {
          return;
        }

        saving.value = true;
        updatePrizePrice({
          merchandiseCansaleId: props.row.merchandiseCansaleId,
          price: form.price,
          __repeat: true,
          __warn: true
        }).then(data => {
          if (data.success) {
            ElMessage.success(data.msg || '操作成功');
            visible.value = false;
            emit('success');
          }
        }).finally(() => {
          saving.value = false;
        });
      });
      return _handleConfirm.apply(this, arguments);
    }

    return (_ctx, _cache) => {
      const _component_el_alert = _resolveComponent("el-alert");

      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "编辑价格",
        width: "360px",
        "destroy-on-close": ""
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          loading: saving.value,
          onClick: handleConfirm
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }, 8, ["loading"])]),
        default: _withCtx(() => [_createVNode(_component_el_alert, {
          class: "price-tip",
          title: "奖品价格将以本次编辑的最新价格覆盖",
          type: "warning",
          closable: false,
          "show-icon": ""
        }), _createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form,
          rules: rules,
          "label-width": "80px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "奖品价格",
            prop: "price"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: form.price,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.price = $event),
              min: 0.01,
              max: 999999,
              precision: 2,
              step: 0.01,
              style: {
                "width": "200px"
              }
            }, null, 8, ["modelValue", "min", "step"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};